export class FcdProvider {
  public id: number;
  public name: string;
  public mstId: string;
  public mstVersion: number;
  public ncisContractId: number;
}



// WEBPACK FOOTER //
// ./src/app/models/fcdprovider.model.ts